import { render, staticRenderFns } from "./Werkstoffe.vue?vue&type=template&id=35d77660"
import script from "./Werkstoffe.vue?vue&type=script&lang=ts"
export * from "./Werkstoffe.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports